import Sentry from "@/Integrations/Sentry";

const Integrations = { Sentry };

export default Integrations;
